export const APIConfig = {
  // TODO, /api has been removed from the env, apply these changes
  url:
    `${process.env.NEXT_PUBLIC_STRAPI_URL}/api` ?? "http://localhost:1337/api",
};
